// extracted by mini-css-extract-plugin
export default {"button":"Button_button__SDUHE","outlined":"Button_outlined__y+m03","link":"Button_link__HGidX","loader":"Button_loader__fgoDJ","spinner":"Button_spinner__YkU40"};